import { Component } from '@theme/component';
import { morphSection } from '@theme/section-renderer';
import { DiscountUpdateEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';
import { cartPerformance } from '@theme/performance';

/**
 * A custom element that applies a discount to the cart.
 *
 * @typedef {Object} CartDiscountComponentRefs
 * @property {HTMLElement} cartDiscountError - The error element.
 * @property {HTMLElement} cartDiscountErrorDiscountCode - The discount code error element.
 * @property {HTMLElement} cartDiscountErrorShipping - The shipping error element.
 */

/**
 * @extends {Component<CartDiscountComponentRefs>}
 */
class CartDiscount extends Component {
  requiredRefs = ['cartDiscountError', 'cartDiscountErrorDiscountCode', 'cartDiscountErrorShipping'];

  /** @type {AbortController | null} */
  #activeFetch = null;

  #createAbortController() {
    if (this.#activeFetch) {
      this.#activeFetch.abort();
    }

    const abortController = new AbortController();
    this.#activeFetch = abortController;
    return abortController;
  }

  /**
   * Handles updates to the cart note.
   * @param {SubmitEvent} event - The submit event on our form.
   */
  applyDiscount = async (event) => {
    const { cartDiscountError, cartDiscountErrorDiscountCode, cartDiscountErrorShipping } = this.refs;

    event.preventDefault();
    event.stopPropagation();

    

    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const discountCode = form.querySelector('input[name="discount"]');
    if (!(discountCode instanceof HTMLInputElement) || typeof this.dataset.sectionId !== 'string') return;

    const discountCodeValue = discountCode.value;
      var discountMetafield = window.discount_code_metavalue;
              var  hasCodeMatching = false;
               var dateStringSelctedate = $('.datepicker').val();
        var parts = dateStringSelctedate.split('/');
        var formattedSelectedDate = parts[2] + '-' + parts[1] + '-' + parts[0];
        var selectedDate = new Date(formattedSelectedDate);

   discountMetafield.map((discountData)=> 
        {
           var discount_code_metafield = discountData.discount_code;
           var discount_offer_from = discountData.discount_valid_from;
           var discount_offer_to = discountData.discount_code_valid_to;
          var time_error_msg = discountData.time_period_error_message;
          var discount_errorMsg = discountData.discount_code_error_message;
           var hasFreeShippingEnabled = discountData.free_shipping_enable || false;
           const cartsummarytotal_element = document.querySelector('.cart__total-value');
           const totalCartPrice = cartsummarytotal_element.getAttribute('data-cart-original-price')
          //  var totalCartPrice = parseInt(`{{ cart.original_total_price | divided_by: 100}}`);
          var shipping_price_reduction = 'No'
          var free_shipping = 'No'
          var blockShippingPriceReduction =discountData.shipping_reduction_price;
           var blockFreeShipping = discountData.total_order_price;
          
            if ($('#is-not-serviced-by-royal-mail').val() != 'No') {
                if (blockShippingPriceReduction) {
                  shipping_price_reduction = 'Yes';
                  var shipping_price_reduction_value =  parseInt(blockShippingPriceReduction);
               }


               if (blockFreeShipping) {
                   var free_shipping_value = parseInt(blockFreeShipping);
                 if(totalCartPrice >= free_shipping_value){
                   free_shipping = 'Yes'
                    }
               }
            }
             if (discount_code_metafield.toLowerCase() == discountCodeValue.toLowerCase()) {
                hasCodeMatching = true;
                checkDiscountVaidity(selectedDate, discount_offer_from, discount_offer_to, time_error_msg, discount_errorMsg, hasFreeShippingEnabled, free_shipping); 
                // checkDiscountVaidity(selectedDate, discount_offer_from, discount_offer_to, time_error_msg, discount_errorMsg);
               // Function to add discount code on has saturday attribute - until only one attribute is possible
                // addFunctionAttribute(discountCodeAdded)
               // check shipping price reduction is true or not

                if(shipping_price_reduction == 'Yes' ){
                  if(totalCartPrice <= shipping_price_reduction_value ){
                    $('#shipping_price_reduction').val('Yes');
                  }
                }

               if(free_shipping == 'Yes'){
                    $('#free_shipping').val('Yes');
                    localStorage.setItem('dukesshipping','Yes')
                     localStorage.setItem('fromDiscountBox','Yes')
                }
             }
        });


        function checkDiscountVaidity(selectedDate, discount_offer_from, discount_offer_to, time_error_msg, errorMsg, hasFreeShippingEnabled, free_shipping){
// conveting the selected date which is in format Thu Nov 21 2024 05:45:00 GMT+0545 (Nepal Time) to 2024-11-21T00:00:00.000Z
     const selected = new Date(selectedDate); 
     const convertedDate = selected.toISOString(); 
     const cart_discount_ele =  document.querySelector('.cart-discount__error');
     const checkoutbutton = $('#checkout')
        if (convertedDate >= discount_offer_from && convertedDate <= discount_offer_to) {
          // checkoutbutton.re
            // enableCheckout();
            // applyDiscount(discountCodeInput.value, errorMsg, hasFreeShippingEnabled, free_shipping);
        } else {
          if(cart_discount_ele) cart_discount_ele.classList.remove('hidden')
          if(time_error_msg){
             $('.discount-alert-container span').text(time_error_msg)
          }else{
            $('.discount-alert-container span').text(`{{ section.settings.time_error__msg | strip }}`);
          }
            disableCheckoutButton();
        }
    }



    const abortController = this.#createAbortController();

    try {
      const existingDiscounts = this.#existingDiscounts();
      if (existingDiscounts.includes(discountCodeValue)) return;

      cartDiscountError.classList.add('hidden');
      cartDiscountErrorDiscountCode.classList.add('hidden');
      cartDiscountErrorShipping.classList.add('hidden');

      const config = fetchConfig('json', {
        body: JSON.stringify({
          discount: [...existingDiscounts, discountCodeValue].join(','),
          sections: [this.dataset.sectionId],
        }),
      });

      const response = await fetch(Theme.routes.cart_update_url, {
        ...config,
        signal: abortController.signal,
      });

      const data = await response.json();

      if (
        data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        discountCode.value = '';
        this.#handleDiscountError('discount_code');
        return;
      }

      const newHtml = data.sections[this.dataset.sectionId];
      const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      const section = parsedHtml.getElementById(`shopify-section-${this.dataset.sectionId}`);
      const discountCodes = section?.querySelectorAll('.cart-discount__pill') || [];
      if (section) {
        const codes = Array.from(discountCodes)
          .map((element) => (element instanceof HTMLLIElement ? element.dataset.discountCode : null))
          .filter(Boolean);
        // Before morphing, we need to check if the shipping discount is applicable in the UI
        // we check the liquid logic compared to the cart payload to assess whether we leveraged
        // a valid shipping discount code.
        if (
          codes.length === existingDiscounts.length &&
          codes.every((/** @type {string} */ code) => existingDiscounts.includes(code)) &&
          data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
            return discount.code === discountCodeValue && discount.applicable === true;
          })
        ) {
          this.#handleDiscountError('shipping');
          discountCode.value = '';
          return;
        }
      }

      document.dispatchEvent(new DiscountUpdateEvent(data, this.id));
    
   morphSection(this.dataset.sectionId, newHtml,true);


    } catch (error) {
      // Something went wrong, should we retry?
    } finally {
      this.#activeFetch = null;
      cartPerformance.measureFromEvent('discount-update:user-action', event);
    }
  };

  /**
   * Handles removing a discount from the cart.
   * @param {MouseEvent | KeyboardEvent} event - The mouse or keyboard event in our pill.
   */
  removeDiscount = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (
      (event instanceof KeyboardEvent && event.key !== 'Enter') ||
      !(event instanceof MouseEvent) ||
      !(event.target instanceof HTMLElement) ||
      typeof this.dataset.sectionId !== 'string'
    ) {
      return;
    }

    const pill = event.target.closest('.cart-discount__pill');
    if (!(pill instanceof HTMLLIElement)) return;

    const discountCode = pill.dataset.discountCode;
    if (!discountCode) return;

    const existingDiscounts = this.#existingDiscounts();
    const index = existingDiscounts.indexOf(discountCode);
    if (index === -1) return;

    existingDiscounts.splice(index, 1);

    const abortController = this.#createAbortController();

    try {
      const config = fetchConfig('json', {
        body: JSON.stringify({ discount: existingDiscounts.join(','), sections: [this.dataset.sectionId] }),
      });

      const response = await fetch(Theme.routes.cart_update_url, {
        ...config,
        signal: abortController.signal,
      });

      const data = await response.json();

      document.dispatchEvent(new DiscountUpdateEvent(data, this.id));
      localStorage.removeItem('discountCode');
      // morphSection(this.dataset.sectionId, data.sections[this.dataset.sectionId],true);
     location.reload()
      // CartItems.init(document.body)
    } catch (error) {
      // Something went wrong, should we retry?
    } finally {
      this.#activeFetch = null;
    }
  };

  /**
   * Handles the discount error.
   *
   * @param {'discount_code' | 'shipping'} type - The type of discount error.
   */
  #handleDiscountError(type) {
    const { cartDiscountError, cartDiscountErrorDiscountCode, cartDiscountErrorShipping } = this.refs;
    const target = type === 'discount_code' ? cartDiscountErrorDiscountCode : cartDiscountErrorShipping;
    cartDiscountError.classList.remove('hidden');
    target.classList.remove('hidden');
  }

  /**
   * Returns an array of existing discount codes.
   * @returns {string[]}
   */
  #existingDiscounts() {
    /** @type {string[]} */
    const discountCodes = [];
    const discountPills = this.querySelectorAll('.cart-discount__pill');
    for (const pill of discountPills) {
      if (pill instanceof HTMLLIElement && typeof pill.dataset.discountCode === 'string') {
        discountCodes.push(pill.dataset.discountCode);
      }
    }

    return discountCodes;
  }





}

if (!customElements.get('cart-discount-component')) {
  customElements.define('cart-discount-component', CartDiscount);
}



















